
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
   Flits(window).on('Flits:setPhoneCountryCode:Loaded', function(event){  
    Flits.settings = event.detail.settings;
    Flits.settings.country_list = [{
      countryName: 'Japan',
      code: 'JP',
      phoneCode: '81'
    }]     
  });

  Flits(document).on('Flits:profileTemplate:Loaded', function(event){  
    var data = event.detail;
    Flits.shopCountryName = 'Japan'
  });
  
  setTimeout(function(){
    if(window.location.pathname == '/cart' && Flits.customer_id != -1){
      Flits.checkAndSetupStoreCreditDiv();
    }
  }, 3000);
  
}(Flits));
